import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ParametresService } from 'global/services/parametres/parametres.service';
import { LoginService } from 'global/services/login/login.service';
import * as _ from 'lodash';


@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {

    parametres;

    constructor(private router: Router, private parametresService: ParametresService, private loginService: LoginService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        this.parametres = this.parametresService.getParametres();
        const excludes = ['home-board','orga-board','user','support', 'jupiter'];
        return this.loginService.getUser().then(user => {
            if (!this.parametres) {
                this.parametres = this.parametresService.getParametres();
            }
            const urlWithoutQueryParams = state.url.split('?')[0];
            const objective = _.compact(urlWithoutQueryParams.split('/'))[0];
            if(excludes.includes(objective)) return true;
            const bloc = _.find(this.parametres.routes, ['path', objective]);
            if (bloc && user && _.find(user.blocs, ['id', bloc.id])) {
                return true;
            } else {
                const urlWithoutQueryParams = state.url.split('?')[0];
                const objective = _.compact(urlWithoutQueryParams.split('/'))[0];
                if (objective === 'jupiter') {
                    sessionStorage.setItem('lastRoute', state.url);
                }
                this.router.navigate(['/login']);
                return false;
            }
        }).catch(err => {
            const urlWithoutQueryParams = state.url.split('?')[0];
            const objective = _.compact(urlWithoutQueryParams.split('/'))[0];
            if (objective === 'jupiter') {
                sessionStorage.setItem('lastRoute', state.url);
            }
            this.router.navigate(['/login']);
            return false;
        });
    }

    canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        this.parametres = this.parametresService.getParametres();
        return this.loginService.getUser().then(user => {
            if (!this.parametres) {
                this.parametres = this.parametresService.getParametres();
            }
            const urlWithoutQueryParams = state.url.split('?')[0];
            const blocObjective = _.compact(urlWithoutQueryParams.split('/'))[0];
            const moduleObjective = _.compact(urlWithoutQueryParams.split('/'))[1];
            const functionObjective = _.compact(urlWithoutQueryParams.split('/'))[2];
            const bloc = _.find(this.parametres.routes, ['path', blocObjective]);
            if (!user || !bloc) {
                console.error('Bloc non accessible');
                this.router.navigate(['/login']);
                return false;
            }
            let module;
            const userBloc = _.find(user.blocs, ['id', bloc.id]);
            if (userBloc) {
                userBloc.modules.forEach((userModule: any) => {
                    const moduleFind = _.find(this.parametres.routes, ['id', userModule.id]);
                    if (moduleFind && moduleFind.path == moduleObjective) {
                        module = _.find(this.parametres.routes, ['id', userModule.id]);
                    } else if (_.find(this.parametres.routes, ['id', functionObjective])) {
                        module = _.find(this.parametres.routes, ['id', functionObjective]);
                    }
                });
                userBloc.modules = userBloc.modules.map(mod => {
                    if (mod.id === 'planExport' && mod.readWrite === 1) {
                        if (!_.find(mod.children, ['id', 'autreproduit'])) {
                            mod.children.push({id: 'autreproduit', label: 'Autre produit', readWrite: 1});
                        }
                    }
                    let res;
                    if (mod.children) {
                        res = [mod.children];
                        delete mod.children;
                        res.push(mod);
                    } else {
                        res = mod;
                    }
                    return res;
                });
                userBloc.modules = _.flattenDeep(userBloc.modules);
            }
            if (userBloc && module && _.find(userBloc.modules, ['id', module.id])) {
                if (functionObjective == 'add' && !_.find(userBloc.modules, ['id', module.id]).readWrite) {
                    console.error('Non accessible en lecture seule');
                    this.router.navigate(['/login']);
                    return false;
                } else {
                    return true;
                }
            } else {
                console.error('Bloc non accessible');
                this.router.navigate(['/login']);
                return false;
            }
        }).catch(err => {
            this.router.navigate(['/login']);
            return false;
        });
    }
}
